import aws from './onboarding.sources/aws.svg'
import azure from './onboarding.sources/azure.svg'
import azureAD from './onboarding.sources/azure.ad.svg'
import azureSubscription from './azure-subscription.svg'
import gcp from './onboarding.sources/gcp.svg'
import gcpSubscription from './google-cloud-subscription.svg'
import okta from './onboarding.sources/okta.svg'
import { CloudTypeEnum } from '../endpoints/services/base.service'
const accounts = { aws, azure, azureAD, azureSubscription, gcp }

export const accountsLogo = (subscription?: boolean) => ({
  [CloudTypeEnum.AWS]: aws,
  [CloudTypeEnum.AZURE]: subscription ? azureSubscription : azure,
  [CloudTypeEnum.GCP]: subscription ? gcpSubscription : gcp,
  [CloudTypeEnum.IDP_AZURE_AD]: azureAD,
  [CloudTypeEnum.IDP_OKTA]: okta
})

export default { accounts }
